var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daohang contentCss"},[_vm._v(" 您所在的位置："),_c('span',[_c('span',{staticClass:"clickSyCss",on:{"click":_vm.tizozhaunSYClick}},[_vm._v("首页")]),_c('span',{staticStyle:{"color":"#000"}},[_vm._v(" / "+_vm._s(_vm.Sydata))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }